/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/408-vine': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.012 7.953a5.297 5.297 0 01-1.169.137c-2.019 0-3.572-1.409-3.572-3.862 0-1.203.466-1.825 1.122-1.825.625 0 1.041.559 1.041 1.697 0 .647-.172 1.356-.3 1.775 0 0 .622 1.084 2.322.753.363-.803.556-1.841.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016H.987c1.259 9.675 5.006 12.756 6 13.347.559.337 1.044.322 1.556.031.806-.456 3.222-2.875 4.563-5.703.563 0 1.238-.066 1.909-.219V7.953z"/>'
  }
})
